<template>
  <div id="app">
    <Header :companyLogo="companyLogo" :imgwidth="imgwidth" :imgheight="imgheight" />
    <div :class="[{'AppQuestion': isStartExam}, 'AppBody']">
    <HomeLogon v-if="isLogin" @LogSuccess="LoginSuccess" :server="wsserver" />
    <prepareExam v-if="showExamDescr" @StartSuccess="StartExamination" :server="wsserver" :ExDetails="ExamDetails" :instituteCode="instituteCode" :userExamCode="userExamCode" :hourmsg="hourmsg" :minutesmsg="minutesmsg" :totalquestions="totalquestions" :passscore="passscore" :correctAns="correctAns"/>
    <ExamQuestions v-if="isStartExam" :server="wsserver" :Exam="ExamDetails" :ExQuestion="ExQuestions" :userid="userName" />
    <LoadingSpinner v-if="isloading" :dwidth="spinnerwidth" :dlength="spinnerheight"/>
    </div>
    <Footer/>
    <div class="PlaneFooter"/>
  </div>
</template>

<script>
import store from '@/store'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import HomeLogon from '@/components/HomeLogon.vue'
import prepareExam from '@/components/prepareExam.vue'
import ExamQuestions from '@/components/ExamQuestions.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

var imgsizeRatio = 0
var srcheight = 0
var srcwidth = 0
export default {
  name: 'App',
  store,
  components: {Header, Footer, HomeLogon, prepareExam, ExamQuestions, LoadingSpinner},
  data () {
    return {
      wsserver: {IP: 'api.dovetech.com.ng', Webapp: '/xelenceAWS/', Port: 9443, htp: 'https'},
      instituteCode: '',
      isLogin: true,
      userName: '',
      ExamDetails: '',
      ShowExamHeader: false,
      showExamDescr: false,
      userExamCode: '',
      ExQuestions: {bookedExamSingle: [], bookedexams: '', response: '', timeRemain: ''},
      isStartExam: false,
      companyName: '',
      ExamName: '',
      companyLogo: '',
      LogoDisplay: false,
      hourmsg: '',
      minutesmsg: '',
      correctAns: '',
      passscore: 0,
      totalquestions: 0,
      imgheight: 60,
      imgwidth: 0,
      isloading: false,
      spinnerwidth: '100%',
      spinnerheight: '100%'
    }
  },
  created: function () {
    this.companyLogo = require('@/assets/companyLogo.png')
    imgsizeRatio = (this.companyLogo.width / this.companyLogo.height)
    this.imgwidth = this.imgheight * imgsizeRatio
  },
  computed: {
    updateSpinner: function () {
      return store.getters.getloading
    },
    isShowFooter: function () {
      return store.getters.getShowFooter
    }
  },
  watch: {
    updateSpinner: function (newval, oldval) {
      this.isloading = store.getters.getloading
    }
  },
  methods: {
    LoginSuccess: function (exdetail, ExCode, instcode, usrName) {
      this.isLogin = false
      this.ShowExamHeader = false
      this.showExamDescr = true
      this.ExamDetails = exdetail
      this.userExamCode = ExCode
      this.instituteCode = instcode
      this.userName = usrName
      this.companyName = exdetail.Examination.institution.name
      this.ExamName = exdetail.Examination.shortdescription
      this.userCode = exdetail.UserCode
      srcheight = exdetail.Examination.institution.logolength
      srcwidth = exdetail.Examination.institution.logowidth
      imgsizeRatio = (srcwidth / srcheight)
      this.imgwidth = this.imgheight * imgsizeRatio
      const examtime = exdetail.Examination.examtime
      this.totalquestions = exdetail.Examination.totalquestions
      this.passscore = exdetail.Examination.passscore
      const splt = examtime.split(':')
      if (splt.length > 1) {
        const hrsint = parseInt(examtime.split(':')[0])
        if (hrsint === 0) {
          this.hourmsg = ''
        } else if (hrsint === 1) {
          this.hourmsg = String(hrsint) + ' hour'
        } else {
          this.hourmsg = String(hrsint) + ' hours'
        }
        const mintint = parseInt(examtime.split(':')[1])
        if (mintint === 0) {
          this.minutesmsg = ''
        } else if (mintint === 1) {
          this.minutesmsg = String(mintint) + ' minute'
        } else {
          this.minutesmsg = String(mintint) + ' minutes'
        }
      }
      this.correctAns = Math.ceil(((this.passscore / 100) * this.totalquestions))
      this.companyLogo = 'data:image/png;base64,' + exdetail.Examination.institution.logo
    },
    StartExamination: function (examquest) {
      this.showExamDescr = false
      this.isStartExam = true
      this.ExQuestions = examquest
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#app {
  width: 100%;
  height: 100%;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column;
}
.AppBody{
  width: 100%;
  height: 530px;
  background-color: white;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction:row;
  -ms-flex-direction:row;
  flex-direction:row;
  justify-content: center;
}
.AppQuestion {
  width: 100%;
  height: 530px;
  background-color: white;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column;
}
@media screen and (min-width:1025px) {
  .PlaneFooter {
    display: none;
    visibility: hidden;
  }
  Footer {
    display: block;
    visibility: visible;
  }
}
@media screen and (max-width:1024px) {
  .AppBody{
    height: 100%;
  }
  .AppQuestion {
    height: 100%;
  }
  .AppHeader {
    position: fixed;
    left: 0;
    top: 0;
  }
  Footer {
    display: none;
    visibility: hidden;
  }
  .PlaneFooter {
    height: 40px;
    display: block;
    visibility: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue